import React, { useState, useEffect } from 'react';
import { Row, Col, Form, Tabs, Radio, notification,message,Modal } from 'antd';
import {
  Button,
  Layout,
  Phone,
  MessageSteps,
  SelectFile,
  ReceiverList,
  Footer,
  SelectGroupList,
  InfoBox
} from 'components';

import MessagesSummary from '../messages-summary';

import ArrowRight from 'assests/icons/arrow-right';
import UploadIcon from 'assests/icons/upload.icon';

import './steps.less';
import './receivers.less';
import ArrowLeft from 'assests/icons/arrow-left';
import { useDimensions } from 'context/dimensions.context';
import classNames from 'classnames';

import * as infoService from 'services/info.service';
import * as phonebookService from 'services/phonebook.service';
import { customMessages } from 'utils';
import { useJob } from 'context/job.context';


const Receivers = (props) => {
  const { isPc } = useDimensions();
  const { currentJob, setCurrentJob } = useJob();
  const [selectedRadio, setSelectedRadio] = useState(1);
  const [form] = Form.useForm();
  const [selectedCircles, setSelectedCircles] = useState([]);
  const [selectedContacts, setSelectedContacts] = useState([]);
  const [receiverCount, setReceiverCount] = useState(currentJob?.receivers ? currentJob?.receivers : 0);
  const [parameterType, setParameterType] = useState(currentJob?.parameterType ? currentJob?.parameterType : 1);
  const [messageType, setMessageType] = useState(currentJob?.messageType ? currentJob?.messageType : 0);
  
  const [valid, setValid] = useState(currentJob?.messageType==3 ? true  : false);


  //useEffect(() => {
 //   setValid(receiverCount>0);
  //}, [receiverCount])
 

  const onValuesChange = (a, b) => {
    // setTimeout(() => {
    //   let inputs = form.getFieldsError();

    //   for (var i = 0; i < inputs.length; i++) {
    //     let formItemName = inputs[i]['name'][0];
    //     if (checkError(formItemName)) {
    //       setValid(true);
    //     } else {
    //       setValid(false);
    //       break;
    //     }
    //   }
    // }, 10);
  };

  const checkError = (fieldName) => {
    if (
      form.getFieldError(fieldName).length === 0
    ) {
      return true;
    }
  };

 

  function onContactListChange(item) {
        setValid(false);
        setSelectedCircles(item);
        phonebookService.updatePhonebook({
          circles:item,contacts:selectedContacts,
        }).then((result) => {
          infoService.getRecipientsByType("all").then((res) => {
                setReceiverCount(res.properties.size);
                if (res.properties.size>0)
                {
                  setValid(true);
                }
                
          });
          
        }).catch((response) => {
          message.error(customMessages.getMessage(response.responseCode));
        });
      // }).catch((response) => {
      //   message.error(customMessages.getMessage(response.responseCode));
      // });
  }

  function onContactChange(item) {
    
    setValid(false);
    setSelectedContacts(item);
    phonebookService.updatePhonebook({
      circles:selectedCircles,contacts:item,
    }).then((result) => {
      infoService.getRecipientsByType("all").then((res) => {
            setReceiverCount(res.properties.size);
            if (res.properties.size>0)
            {
              setValid(true);
            }
      });
      
    }).catch((response) => {
      message.error(customMessages.getMessage(response.responseCode));
    });
}
  
  

  const onNext =()=> {
    
    form.validateFields().then(values => {
    var data = {
      smsText:currentJob?.messageWithoutEtk,
      etkFlag:currentJob?.etkFlag,
      type:values.sourceType =="1"? 'excel': 'rehber',
      messageType:messageType
    };
    infoService.getTotalCreditByType(data).then((res)=> 
    {
      if (res.totalCredit<1)
      {
        Modal.error({
          title: 'Hata',
          content: customMessages.getMessage('zeroCreditUsage'),
        });
        return;
      }
      values.maxCredit=res.totalCredit;
      values.parameterType=parameterType;
      values.receivers=receiverCount;
      setCurrentJob({...currentJob,...values});
      props.updateCurrent(3);
    }).catch((err)=>
      {
        Modal.error({
          title: 'Hata',
          content: customMessages.getMessage(err.responseCode),
        });
      }
    );


    
   
    
    });
     
  }

  const onListUpload = (e) => {
    
    const file= e.target.files[0];
    if (file)
    {
      phonebookService.onUploadFile(file).then((res) => {
        setReceiverCount(res.contacts.length)
        if (res.contacts.length>0)
        {
          setValid(true);
        }
      })
      .catch((response) => {
        Modal.error({
          title: 'Hata',
          content: customMessages.getMessage(response.responseCode),
        });
      });
    }
   }

  


  return (
  
      <div className="receivers-page">
        <Form
          form={form}
          onValuesChange={onValuesChange}
          name="choose-title"
        >
          <div
            className={classNames('step-transitions', {
              'padding-spaces-none': !isPc,
            })}
          >
            <div className="container">
              <div className="step-transitions_left"></div>
              {isPc ? (
                <div className="step-transitions__right">
                  <Button type="ghost" className="circle"   onClick={()=>  props.updateCurrent(1)}>
                    <ArrowLeft />
                  </Button>
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="ant-btn--icon"
                    onClick={onNext}
                    disabled={!valid}
                  >
                    Gönderim Zamanı
                    <ArrowRight />
                  </Button>
                </div>
              ) : null}
            </div>
          </div>
          <div className="page-content">
            <div className="container">
              <Row className="receivers">
                <Col md={24} lg={24} xl={8} span={24}>
                  <div>
                    <h1 className="box__title">Alıcı Kitlesini Seçin</h1>
                    {(messageType!=3) && 

                    
                    <Form.Item name="sourceType" initialValue={1}>
                      <Radio.Group
                        className="radio-group--v2"
                        onChange={(e) => {
                          setSelectedRadio(e.target.value);
                          setParameterType(e.target.value);
                          setReceiverCount(0);
                          setValid(false);
                        }}
                        value={selectedRadio}
                      >
                        <Radio value={1}>
                          <div className="text-area">Dosyadan Yükle</div>
                          {selectedRadio === 1 ? (
                            <div>
                              <Form.Item
                              
                                name="select-file"
                              >
                                <SelectFile
                                  vertical
                                  type="file"
                                  notification
                                  allowExtensions={["xlsx","xls","txt","zip","vcard"]}
                                  notificationplacement={
                                    isPc ? 'bottomLeft' : 'topLeft'
                                  }
                                  onChange={onListUpload}
                                  notificationMessage="dosyasından seçtipiniz kayıtlar alıcı listesine eklendi"
                                  title={
                                    <p>
                                      Excel, Vcard, Text veya Zip dosyanızdaki
                                      kişileri aktarmak için buraya tıklayın.
                                    </p>
                                  }
                                  icon={<UploadIcon />}
                                />
                              </Form.Item>
                              <p className="info-text">
                                Eğer Excel yüklerken sorun yaşıyorsanız düzgün
                                formatı <a href="/samples/ornek.xlsx" download>buradan</a>
                                indirebilirsiniz.
                              </p>
                            </div>
                          ) : null}
                        </Radio>
                        <Radio value={2}>
                          <div className="text-area">Rehberimden Seç</div>
                          {selectedRadio === 2 ? (
                            <Form.Item
                              name="group-list"
                            >
                              <SelectGroupList  onChange={onContactListChange} />
                            </Form.Item>
                          ) : null}
                        </Radio>
                      </Radio.Group>
                    </Form.Item>
                    }
                    {(messageType==3) && (
                <InfoBox
                  type="warning"
                  content={
                    <p>
                     Parametrik gönderim yapıldığı için bu adımı geçebilirsiniz.
                    </p>
                  }
                />
              )}
                  </div>
                </Col>
                <Col
                  s={24}
                  md={{ span: 11 }}
                  lg={{ span: 11 }}
                  xl={{ span: 8, offset: 1 }}
                  span={24}
                >
                  <div>
                  {(messageType!=3 ) && 
                  <div className="receiver-list">
                    <div className="receiver-list__head">
                          <h1 className="box__title--small">Alıcı Sayısı</h1>
                          <span>
                            <strong>{receiverCount}</strong> Alıcı
                          </span>
                        </div>
                        {(selectedRadio==2) &&
                          <ReceiverList  onChange={onContactChange}   />
                        }
                   
                    
                </div>
                  }
                    {/* Version 2 <ReceiverList willSend={235} receiversCounts="125" />  */}
                    {/* Version 3 <ReceiverList empty receiversCounts="125" /> */}
                  </div>
                </Col>
                <Col
                  s={24}
                  md={{ span: 11, offset: 2 }}
                  lg={{ span: 11, offset: 2 }}
                  xl={{ span: 6, offset: 1 }}
                  span={24}
                >
                  <div className="receivers__right">
                  <MessagesSummary
                                  
                                  title={currentJob?.sender}
                                  message={currentJob?.messageText}
                                  receivers={currentJob?.receivers}
                                  reportName={currentJob?.campaignName}
                                  numbersOfSms={currentJob?.maxCredit}
                    />
                  </div>
                </Col>
              </Row>
            </div>
            {!isPc ? (
              <div className="step-transitions__right">
                <Button type="ghost" className="circle"   onClick={()=>  props.updateCurrent(1)}>
                  <ArrowLeft />
                </Button>
                <Button
                  type="primary"
                  htmlType="submit"
                  className="ant-btn--icon"
                  onClick={onNext}
                >
                  Gönderim Zamanı
                  <ArrowRight />
                </Button>
              </div>
            ) : null}
          </div>
        </Form>
      </div>
  );
};

export default Receivers;
